<template>
  <div>
    <ConfigListItem
      label="Freio"
      :value="strValue"
      :date="maxUpdatedAt"
      :login="maxUpdatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :max-width="800">
      <v-card>
        <ODialogBar title="Origem do Freio" @close="dismiss" />
        <v-card-text v-if="readonly" class="pa-6">
          <p>
            O valor da configuração "Uso da Serial" está 0x04, o que impede a
            alteração desta configuração.
          </p>
          <p>
            Entre em contato com o time de desenvolvimento para corrigir.
          </p>
        </v-card-text>
        <v-card-text v-else class="pa-6">
          <div class="d-flex">
            <OVerticalTabs
              class="mr-6"
              v-model="clonedValues.brakeSource"
              :tabs="[
                { value: 'sensor', text: 'Sensor' },
                { value: 'can', text: 'CAN' }
              ]"
            />
            <v-tabs-items
              class="flex-grow-1"
              v-model="clonedValues.brakeSource"
            >
              <div class="px-4" v-if="clonedValues.brakeSource == null">
                Escolha um valor da lista ao lado.
              </div>

              <v-tab-item value="sensor" class="px-4">
                <v-select
                  label="Freio Ativa Bateria"
                  v-model="clonedValues['freio-ativa-bateria']"
                  :items="freioAtivaBateriaOpts"
                  item-text="label"
                />
              </v-tab-item>

              <v-tab-item value="can" class="px-4">
                <SelectCANVariable
                  :canDictId="canDictId"
                  v-model="clonedValues.brakeCanVariable"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <ODialogButtons
          v-if="!readonly"
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import { mostRecentlyUpdated, getCfg, getManyCfgs } from './config-utils.js'
import VehicleCfgs from 'vehicle-cfgs'
import OVerticalTabs from './OVerticalTabs.vue'
import SelectCANVariable from './SelectCANVariable.vue'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs) {
  let cfgs = getManyCfgs(
    allConfigs,
    'canDict',
    'brakeSource',
    'brakeCanVariable',
    'freio-ativa-bateria'
  )

  switch (cfgs.brakeSource) {
    case 'sensor': {
      let x = cfgs['freio-ativa-bateria']
      if (x == '0x00') return `Sensor (1 quando ligado no terra)`
      else return `Sensor (1 quando ligado no VCC)`
    }
    case 'can': {
      let y = cfgs.brakeCanVariable
      return `CAN variable=${y && y.code}`
    }
    default:
      return '???'
  }
}

export function copyValue(allConfigs) {
  return getManyCfgs(
    allConfigs,
    'brakeSource',
    'brakeCanVariable',
    'freio-ativa-bateria'
  )
}

export default {
  components: { ConfigListItem, OVerticalTabs, SelectCANVariable },
  props: {
    vehicle: { required: true },
    allConfigs: { required: true }
  },
  data() {
    return {
      freioAtivaBateriaOpts: VehicleCfgs.get('freio-ativa-bateria', 'opts'),
      clonedValues: { brakeSource: 'sensor' }
    }
  },
  computed: {
    readonly() {
      let x = getCfg(this.allConfigs, 'uso-da-serial')
      return x == '0x04'
    },
    canDictId() {
      return getCfg(this.allConfigs, 'canDictId')
    },
    strValue() {
      return displayValue(this.allConfigs)
    },
    mostRecent() {
      return mostRecentlyUpdated(
        this.allConfigs,
        'brakeSource',
        'brakeCanVariable',
        'freio-ativa-bateria'
      )
    },
    maxUpdatedAt() {
      return this.mostRecent && this.mostRecent.updatedAt
    },
    maxUpdatedBy() {
      return this.mostRecent && this.mostRecent.updatedBy
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValues = getManyCfgs(
        this.allConfigs,
        'brakeSource',
        'brakeCanVariable',
        'freio-ativa-bateria'
      )
      return this.$refs.dialog.$open()
    },
    async save() {
      const payload = this.clonedValues
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style></style>
